import { useNavigate, useLocation } from "react-router-dom"

import Style from "./style"
import useLogoutEvent from "./model/useLogoutEvent"
import menuList from "./asset/menuList"

import useLoginCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"
import { ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER } from "shared/constant/lookup/role"

const Aside = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [loginCookie] = useLoginCookie()
    const [roleCookie] = useRoleCookie()
    const [logoutEvent] = useLogoutEvent()

    const path = location.pathname.split("/")
    const target = path[path.length - 1]
    const deactiveList = ["qr"]

    // 출력하지 않을 Router 명세
    for (let target of deactiveList) {
        if (path.includes(target)) return null
    }
    
    return (
        <>
            {loginCookie && target !== "qr" &&
                <Style.Aside>

                    <Style.MenuList>
                        {menuList[roleCookie]?.map(category =>
                            <Style.CategoryDiv>
                                <h2>{category.title}</h2>
                                {category?.items.map(item =>
                                    <Style.Element $nowPage={location.pathname.split("/")[1] === item?.path.split("/")[1]} onClick={() => navigate(item?.path)}>{item?.name}</Style.Element>
                                )}
                            </Style.CategoryDiv>
                        )}
                    </Style.MenuList>

                    {![ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER].includes(roleCookie) && <Style.EditBtn onClick={() => navigate("/admin/my/edit")}>내 정보 수정</Style.EditBtn>}

                    <Style.LogoutBtn onClick={logoutEvent}>로그아웃</Style.LogoutBtn>

                </Style.Aside>
            }
        </>
    )
}

export default Aside